export default "__VITE_ASSET__C9sQ2$9I__"